import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const DownloadIcon = ({ color, className, width, height }: any) => {
  return (
    <SvgIcon
      style={{ height: height || styles.icon.height, width: width || styles.icon.width }}
      className={className}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7 3.75C12.1142 3.75 12.45 4.08579 12.45 4.5V12.6L16.05 9.9C16.3814 9.65147 16.8515 9.71863 17.1 10.05C17.3485 10.3814 17.2814 10.8515 16.95 11.1L12.15 14.7C11.8833 14.9 11.5167 14.9 11.25 14.7L6.45 11.1C6.11863 10.8515 6.05147 10.3814 6.3 10.05C6.54853 9.71863 7.01863 9.65147 7.35 9.9L10.95 12.6V4.5C10.95 4.08579 11.2858 3.75 11.7 3.75ZM4.5 18.15C4.08579 18.15 3.75 18.4858 3.75 18.9C3.75 19.3142 4.08579 19.65 4.5 19.65H18.9C19.3142 19.65 19.65 19.3142 19.65 18.9C19.65 18.4858 19.3142 18.15 18.9 18.15H4.5Z"
          fill={color || "#333333"}
        />
      </svg>
    </SvgIcon>
  );
};

export default DownloadIcon;
